export const SET_DOCUMENTOS_ANEXOS = "SET_DOCUMENTOS_ANEXOS";
export const SET_DOCUMENTOS_ANEXOS_ARRAY = "SET_DOCUMENTOS_ANEXOS_ARRAY";
export const LOADING_DOCUMENTOS_ANEXOS = "LOADING_DOCUMENTOS_ANEXOS";
export const LOADING_DOCUMENTOS_ANEXOS_ARRAY = "LOADING_DOCUMENTOS_ANEXOS_ARRAY";
export const ERROR_DOCUMENTOS_ANEXOS = "ERROR_DOCUMENTOS_ANEXOS";
export const ERROR_DOCUMENTOS_ANEXOS_ARRAY = "ERROR_DOCUMENTOS_ANEXOS_ARRAY";

export const HANDLE_CHANGE_DOCUMENTOS_ADMINISTRADOR_VALUE_FLAG = "HANDLE_CHANGE_DOCUMENTOS_ADMINISTRADOR_VALUE_FLAG"; 
export const HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAFISICADEZMAIS_VALUE_FLAG = "HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAFISICAQUETENHADEZOUMAIS_VALUE_FLAG"; 
export const HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAFISICAMENOSDEZ_VALUE_FLAG = "HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAFISICAQUETENHAMENOSDEDEZ_VALUE_FLAG"; 
export const HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAJURIDICANACIONAL_VALUE_FLAG = "HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAJURIDICANACIONAL_VALUE_FLAG"; 
export const HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAJURIDICAESTRANGEIRA_VALUE_FLAG = "HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAJURIDICAESTRANGEIRA_VALUE_FLAG"; 
export const HANDLE_CHANGE_DOCUMENTOS_PROCURADOR_VALUE_FLAG = "HANDLE_CHANGE_DOCUMENTOS_PROCURADOR_VALUE_FLAG"; 

export const DELETE_DOCUMENTOS_ANEXO = "DELETE_DOCUMENTOS_ANEXO";
export const DELETE_DOCUMENTOS_ARRAY_ANEXO = "DELETE_DOCUMENTOS_ARRAY_ANEXO";
export const DELETE_GROUP_DOC = "DELETE_GROUP_DOC";
export const DELETE_GROUP_DOC_ARRAY = "DELETE_GROUP_DOC_ARRAY";

export const ADICIONAR_SOCIO_DEZOUMAIS = "ADICIONAR_SOCIO_DEZOUMAIS";
export const ADICIONAR_SOCIO_MENOSDEZ = "ADICIONAR_SOCIO_MENOSDEZ";








